import axios from 'axios';
import validator from 'validator';
import types from './mutations-types';
import router from '../../router';

const url = 'https://api.bi-assobens.com.br/v1';
// const url = 'http://localhost:3000/v1';

const actions = {
  async verifyToken(
    {
      // eslint-disable-next-line
      commit,
    },
    token,
  ) {
    const res = await axios.post(
      `${url}/verifyToken`,
      {},
      {
        headers: {
          'x-access-token': token,
        },
      },
    );
    return res.data;
  },
  async login({ commit }, obj) {
    const res = await axios.post(`${url}/login`, {
      ...obj,
    });
    if (res.data.auth && validator.isJWT(res.data.token)) {
      localStorage.setItem(
        '_pbiAssobens',
        JSON.stringify({
          id: res.data.id,
          token: res.data.token,
          email: obj.email,
          type: res.data.type,
          isSSO: false,
          isVendas: res.data.isVendas,
          isPosVendas: res.data.isPosVendas,
          segmentos: res.data.segmentos,
        }),
      );

      commit(types.SET_JWT, res.data);
      commit(types.SET_EMAIL, obj.email);

      router.push('/home');
    }
  },
  // eslint-disable-next-line
  async logout({ commit }, token) {
    await axios.post(`${url}/logout`, {
      token,
    });
  },
};

export default actions;
